export default function validateTaxCode(taxCode) {
    if (!taxCode || taxCode.trim() === "") {
        return { isValid: false, message: "Mã số thuế không được để trống." };
    }

    const cleanTaxCode = taxCode.trim();

    // Biểu thức chính quy kiểm tra định dạng MST:
    // - Loại 10 chữ số (Doanh nghiệp, hộ kinh doanh, cá nhân): VD: 0110337486
    // - Loại 13 chữ số (Chi nhánh, đơn vị phụ thuộc): VD: 0110337486-001
    const taxCodeRegex = /^(\d{10}|\d{10}-\d{3})$/;

    if (!taxCodeRegex.test(cleanTaxCode)) {
        return { 
            isValid: false, 
            message: "Mã số thuế không đúng định dạng. Phải là 10 chữ số hoặc 13 chữ số theo chuẩn (VD: 0110337486 hoặc 0110337486-001)." 
        };
    }

    return { isValid: true, message: "Mã số thuế hợp lệ." };
}
